<template>
  <div class="counter-component-container">
    <div
      :class="`counter text-xs font-medium text-secondary ${primary ? 'primary' : ''} ${alert ? 'alert' : ''}`"
    >
      {{ count }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      count: {
        type: [Number, String],
        default: 0,
      },
      primary: {
        type: Boolean,
        default: false,
      },
      // Red, for labels that need to stand out
      alert: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style lang='scss' scoped>
.counter-component-container {
  text-align: left;

  .counter {
    background-color: var(--bg-secondary);
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-full);
    padding: var(--spacing-xxs) var(--spacing-md);

    &.primary {
      background-color: var(--bg-brand-primary);
      border-color: var(--utility-brand-200);
      color: var(--utility-brand-700);
    }

    &.alert {
      background-color: var(--utility-error-50, #fef2f2);
      border-color: var(--utility-error-200, #fecaca);
      color: var(--utility-error-700, #b91c1c);
      font-weight: 600;
    }
  }
}
</style>
